module.exports = __webpack_public_path__ + "img/kairan.47188ee5.png";